import { defineComponent as n, createBlock as r, openBlock as a, unref as p, mergeProps as m, withCtx as l, createElementVNode as c } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const d = /* @__PURE__ */ n({
  name: "IconEqual",
  __name: "IconEqual",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (u, e) => (a(), r(p(s), m(o, { "view-box": "0 0 24 24" }), {
      default: l(() => [...e[0] || (e[0] = [
        c("path", { d: "M21 8.75a.75.75 0 0 0 0-1.5H3a.75.75 0 0 0 0 1.5h18m-18 6.5a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5H3" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
